var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jr-echarts',{ref:"echartsRef",attrs:{"options":_vm.chartOptions,"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }